import React, { FC, useState } from 'react'
import { Paper, Typography, IconButton, Theme, Link } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import CloseIcon from '@material-ui/icons/Close'
import { useAdOptInStatus } from 'src/hooks/useAdOptInStatus'
import { history } from 'src/app'
import { AD_NETWORK_OVERVIEW_PAGE_URL, WORKSPACE_ID_PARAM } from 'src/constants/urlConstants'
import useWorkspaceId from 'src/hooks/useWorkspaceId'
import { shouldShowAdNetworkOptInBanner } from './ad-network-opt-in-banner.helpers'

const usePaperClasses = makeStyles<Theme>({
  root: {
    backgroundColor: '#FFFFFF',
    padding: '0 30px',
    width: '100%',
    minHeight: 32,
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    zIndex: 5,
    justifyContent: 'center',
    whiteSpace: 'nowrap',
    boxShadow: 'none'
  }
})

export const AdNetworkOptInBanner: FC = () => {
  const [dismissed, setDismissed] = useState(false)
  const workspaceId = useWorkspaceId()
  const adOptInStatus = useAdOptInStatus()
  const paperClasses = usePaperClasses()

  if (!shouldShowAdNetworkOptInBanner({ dismissed, adOptInStatus })) return <></>

  const handleClick = () => {
    if (!workspaceId) return
    const url = AD_NETWORK_OVERVIEW_PAGE_URL.replace(WORKSPACE_ID_PARAM, workspaceId)
    history.push(url)
  }

  return (
    <Paper classes={paperClasses} elevation={0} square>
      <Typography variant="body2" style={{ fontSize: 13 }}>
        <Link
          component="button"
          variant="body2"
          onClick={handleClick}
          style={{ fontSize: 13, fontWeight: 500 }}
        >
          Click here
        </Link>
        {' '}to learn how to earn revenue from your sign.
      </Typography>
      <IconButton
        size="small"
        onClick={() => setDismissed(true)}
        style={{ position: 'absolute', right: 8 }}
      >
        <CloseIcon style={{ fontSize: 16 }} />
      </IconButton>
    </Paper>
  )
}
